import { ROUTE_TEST_DETAILS, ROUTE_TESTING_PLAN_COMPLETE } from '@/constants/routes';
import { Box, Flex, IconCheck, Link, Text } from '@cmpsr/components';
import { NavLink } from 'react-router-dom';
import { TestPlanScreeningType } from '../../app/components/testing-plan/components/your-testing-plan/types';
import TestHeader from './components/header/header';
import TargetDate from './components/target-date/target-date';
import useTestingSummaryCardController from './testing-summary-card.controller';
import { getRoute } from '@/utils';
import { useCompleteTestingPlan } from '@/queries/testing-plan.queries';

type ScreeningTypeProps = {
  screeningTypeData: TestPlanScreeningType;
  restricted?: boolean;
};

export default function TestingSummaryCard({ screeningTypeData, restricted }: ScreeningTypeProps) {
  const completeTestMutation = useCompleteTestingPlan();
  const testingSummary = useTestingSummaryCardController(screeningTypeData);
  if (!testingSummary) return null;

  const { name, what, why, testSuggestionId, targetDate, handleDateChange } = testingSummary;

  return (
    <Box
      as="section"
      backgroundColor="background-light"
      border="1px solid"
      borderColor="ui-element-divider"
      borderRadius="radii-3"
    >
      <TestHeader {...screeningTypeData} />
      <Flex direction="column" gap={3} px={{ base: 5, lg: 6 }} mb={4} flexGrow="1">
        <Flex display={{ base: 'block', xxl: 'flex' }} gap="4" mb="2">
          <Text variant="text-header-L">{name}</Text>
        </Flex>
        <TargetDate initialDate={targetDate} onDateChange={handleDateChange} />
        <Box>
          <Text variant="text-body-regular" mb={2}>
            <Text as="span" fontWeight="bold">
              What:
            </Text>{' '}
            {what}
          </Text>
          <Text variant="text-body-regular">
            <Text as="span" fontWeight="bold">
              Why:
            </Text>{' '}
            {why}
          </Text>
        </Box>
      </Flex>
      <Flex as="footer" pt={3} px={{ base: 5, lg: 6 }} pb={5} gap={{ base: 2, lg: 3 }}>
        <Link
          as={NavLink}
          to={getRoute(ROUTE_TEST_DETAILS, { idTest: testSuggestionId })}
          variant="primary-alt"
          flex={{ base: '1', md: '1 1 50%' }}
          justifyContent="center"
          height="fit-content"
          border="2px solid"
        >
          Details
        </Link>
        {!restricted && (
          <Link
            as={NavLink}
            to={getRoute(ROUTE_TESTING_PLAN_COMPLETE, { idTestOption: testSuggestionId })}
            onClick={() => {
              void completeTestMutation.mutateAsync(testSuggestionId);
            }}
            variant="primary"
            flex={{ base: '1 0 auto', md: '1 1 50%' }}
            justifyContent="center"
            height="fit-content"
            leadingIcon={<IconCheck />}
            textAlign="center"
          >
            Mark as complete
          </Link>
        )}
      </Flex>
    </Box>
  );
}
